import { Component, OnInit } from '@angular/core';
import { FormGroup, FormBuilder, Validators } from '@angular/forms';
import { Subscription, Observable } from 'rxjs';
import { UserService } from '../../../../../admin/src/app/services/user.service';
import { AppValidationsHelper } from '../../../../../admin/src/app/app-validations.helper';
import { User } from '../../../../../admin/src/app/models/user';
import { DropdownItem } from '../../../../../admin/src/app/components/dropdown/dropdown.component';
import { ApiResponse } from '../../../../../admin/src/app/models/api-response';
import { LanguageService } from '../../services/language.service';
import { MatomoTracker } from 'ngx-matomo';

@Component({
  selector: 'app-user-profile',
  templateUrl: './user-profile.component.html',
  styleUrls: ['./user-profile.component.css']
})
export class UserProfileComponent implements OnInit {

  user: User;

  form: FormGroup;

  countriesMap = {};

  unassignedCountries: DropdownItem[] = [];

  unassignedProvinces: DropdownItem[] = [];

  sub: Subscription;

  constructor(
    private fb: FormBuilder,
    private userSvc: UserService,
    public language: LanguageService,
    private matomoTracker: MatomoTracker
  ) { }

  ngOnInit() {
    this.matomoTracker.trackPageView('User profile');

    this.getCountryList().subscribe(() => {
      this.user = this.userSvc.getUserInfo();

      if (!!this.user.countryCode) {
        this.getProvinceList(this.user.countryCode);
      }

      this.form = this.fb.group({
        firstName: [this.user.firstName],
        lastName: [this.user.lastName],
        taxCode: [this.user.taxCode],
        countryCode: [this.user.countryCode],
        province: [this.user.province],
        city: [this.user.city],
        zipCode: [this.user.zipCode],
        address: [this.user.address]
      });

      this.form.get('countryCode').valueChanges.subscribe(val => {
        this.getProvinceList(val);
      });
    });
  }

  fillNullValues(user: User, keys: string[]) {
    keys.forEach(k => {
      user[k] = user[k] === null ? '' : user[k];
    });
    return user;
  }

  save() {
    this.form.markAsTouched();
    this.form.markAsDirty();

    if (this.form.valid) {
      let user = Object.assign({ uid: this.user.uid, language: this.user.language }, this.form.value);
      user = this.fillNullValues(user, ['language', 'taxCode', 'countryCode', 'province', 'city', 'zipCode', 'address']);

      console.log('Saving user', this.user, user);
      return new Observable<ApiResponse<User>>(observer => {
        this.userSvc.update(null, user).subscribe(data => {
          this.form.markAsPristine();
          this.form.markAsUntouched();
          observer.next(data);
          observer.complete();
        });
      }).subscribe(data => {
        console.log('Saved user with id %s', data.payload.id, data.payload);
        this.afterSave(data);
      });
    } else {
      AppValidationsHelper.validateFormFields(this.form);
    }
  }

  afterSave(data: ApiResponse<User>) {
    this.user = Object.assign({}, data.payload);
  }

  getCountryList() {
    return new Observable(observer => {
      this.userSvc.getCountries().subscribe(data => {
        let countries = data.payload.elements;
        this.countriesMap = {};
        countries.forEach(country => {
          this.countriesMap[country.code] = country;
        });
        this.unassignedCountries = countries.map(c => <DropdownItem>{ label: c.name, value: c.code } );
        observer.next();
        observer.complete();
      });
    });
  }

  private getProvinceList(countryCode: string) {
    this.unassignedProvinces = [];
    let country = this.countriesMap[countryCode];
    let provincies = !!country ? country.states : null;
    if (!!provincies && provincies.length) {
      provincies.forEach(p => {
        this.unassignedProvinces.push(<DropdownItem>{ label: p.name, value: p.code });
      });
    }
  }

}
